<template>
  <div class="upload uploads">
    <bread :list="list"></bread>
    <!--  -->
    <div>
      <div class="step flex text-ff justify-between text-center align-center">
        <div class="step1">
          <div class="step_img">1</div>
          <div class="text-12 text-1a">选择品牌</div>
        </div>
        <div class="line"></div>
        <div class="step2">
          <div class="step_img">2</div>
          <div class="text-12 text-1a">上传资料</div>
        </div>
        <div class="line" style="background: #d9d9d9;"></div>
        <div class="step3">
          <div class="step_img">3</div>
          <div class="text-12 text-1a">完成</div>
        </div>
      </div>
      <!--  -->
      <div style="width: 50%;margin: 0 auto;">
        <div class="flex align-center msg_li">
          <div class="msg_li_title">品牌LOGO：</div>
          <el-upload
            class="avatar-uploader"
            action=" http://glc.ilianpei.com/common/upload/image/qiniu"
            :http-request="myUpload1"
            accept="image/png, image/jpg, image/jpeg"
            :on-success="handLogo"
            :before-upload="beforeAvatarUpload"
            disabled
          >
            <img v-if="logoUrl" :src="logoUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <!-- <div style="font-size:14px;color:#999;margin-left: 10px;">提示：LOGO图上传最大建议为50k</div> -->
        </div>
        <div class="flex align-center msg_li">
          <div class="msg_li_title">品牌名称：</div>
          <input type="text" disabled v-model="brand_title" placeholder="这里是品牌名称" />
        </div>
        <div class="flex align-center msg_li">
          <div class="msg_li_title">上传证书：</div>
          <el-upload
            class="avatar-uploader"
            style="width: 98px;height: 98px;"
            action=" http://glc.ilianpei.com/common/upload/image/qiniu"
            :http-request="myUpload2"
            accept="image/png, image/jpg, image/jpeg"
            :on-success="handCard"
            :before-upload="beforeAvatarUpload2"
          >
            <img v-if="cardUrl" :src="cardUrl" class="avatar" />
            <i v-if="addShow2" class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <enlargePic class="shili" :src="$shili_brandUploads" :imgSrc="[$shili_brandUploads]" ></enlargePic>
        </div>
        <div class="flex align-center msg_li">
          <div class="msg_li_title">有效期：</div>
          <div class="block">
            <el-date-picker v-model="value1" type="date" placeholder="选择日期" @change="timeChange"></el-date-picker>
          </div>
        </div>
      </div>
    </div>

    <div class="btns">
      <button class="poi" @click="getAdd">下一步</button>
      <button class="poi" @click="$router.go(-1)">返回</button>
    </div>
  </div>
</template>

<script>
import bread from "../../../components/bread";
import enlargePic from "../../../components/enlargePic.vue";
export default {
  components: {
    bread,
    enlargePic
  },
  data() {
    return {
      addShow: true,
      addShow2: true,
      list: [
        {
          title: "信息管理"
        },
        {
          title: "品牌管理"
        },
        {
          title: "代理品牌"
        },
        {
          title: "申请代理品牌"
        }
      ],
      logoUrl: "",
      cardUrl: "",
      value1: "",
      brand_title: "",
      btnDis: true
    };
  },
  mounted() {
    this.post(this, "/home/getbrandInfo", {
      token: window.localStorage.getItem("pc_token"),
      brand_id: this.$route.query.id
    }).then(res => {
      if(res.data.code == 0){
        this.btnDis = false;
      }
      this.logoUrl = res.data.data.thumb;
      this.brand_title = res.data.data.brand_title;
    });
  },
  methods: {
    timeChange(e) {
      this.value1 =
        e.getFullYear() + "-" + (e.getMonth() + 1) + "-" + e.getDate();
    },
    myUpload1(content) {
      var formdata = new FormData();
      formdata.append("file", content.file);
      formdata.append("type", 4);
      this.axios
        .post(content.action, formdata, {
          onUploadProgress: progressEvent => {
            let num = ((progressEvent.loaded / progressEvent.total) * 100) | 0; //百分比
            content.onProgress({ percent: num }); //进度条
          }
        })
        .then(res => {
          content.onSuccess(res.data);
        });
    },
    handLogo(res, file) {
      this.logoUrl = res.url;
    },
    myUpload2(content) {
      var formdata = new FormData();
      formdata.append("file", content.file);
      formdata.append("type", 7);
      this.axios
        .post(content.action, formdata, {
          onUploadProgress: progressEvent => {
            let num = ((progressEvent.loaded / progressEvent.total) * 100) | 0; //百分比
            content.onProgress({ percent: num }); //进度条
          }
        })
        .then(res => {
          content.onSuccess(res.data);
        });
    },
    handCard(res, file) {
      this.cardUrl = res.url;
    },
    getAdd() {
      if(this.btnDis){
        return false
      }
      if (!this.brand_title){
        this.$message.error("品牌名称不能为空");
        return false;
      }else if(!this.cardUrl){
        this.$message.error("请上传证书");
        return false;
      }else if(!this.value1){
        this.$message.error("请选择有效期");
        return false;
      }
      this.post(this, "/home/addBrand", {
        token: window.localStorage.getItem("pc_token"),
        type: 2,
        brand_id: this.$route.query.id,
        brand_title: this.brand_title,
        brand_logo: this.logoUrl,
        barnd_book: this.cardUrl,
        brand_time: this.value1
      }).then(res => {
        if (res.data.code == 0) {
          this.$message.success(res.data.msg);
            this.$router.push({
              name: "brandComplete",
              params: {
                typeId: res.data.type
              }
            });
        }
      });
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt1M = file.size / 1024 / 1024 < 0.05;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式!");
      }
      if (!isLt1M) {
        this.$message.error("上传图片大小不能超过 50k!");
      }
      if (isJPG && isLt1M) {
        this.addShow = false
      }
      return isJPG && isLt1M;
    },
    beforeAvatarUpload2(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt1M = file.size / 1024 / 1024 < 1;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式!");
      }
      if (!isLt1M) {
        this.$message.error("上传图片大小不能超过 1MB!");
      }
      if (isJPG && isLt1M) {
        this.addShow2 = false
      }
      return isJPG && isLt1M;
    }
  }
};
</script>

<style scoped>
input[type="text"] {
  width: 400px;
  height: 34px;
  line-height: 34px;
  border: 1px solid #eeeeee;
  padding: 0 10px;
  font-size: 14px;
}
.msg_li {
  padding: 10px 0;
}
.msg_li_title {
  width: 100px;
  text-align: right;
  margin-right: 10px;
}
.step {
  width: 430px;
  margin: 20px auto;
}
.step_img {
  width: 44px;
  height: 34px;
  text-align: center;
  line-height: 34px;
  position: relative;
  margin: 0 auto 20px;
}
.step1 .step_img {
  background: url("../../../public/img/step1.png") no-repeat;
  background-size: 100% 100% !important;
}
.step2 .step_img {
  background-size: 100% 100% !important;
  background: url("../../../public/img/step1.png") no-repeat;
}
.step3 .step_img {
  width: 34px;
  background: url("../../../public/img/step2.png") no-repeat;
  background-size: 100% 100%;
}
.line {
  height: 1px;
  flex-grow: 1;
  background: #ff7b00;
  transform: translateY(-15px);
}
.btns {
  margin: 60px 60px 100px;
  text-align: center;
}
.btns button {
  width: 104px;
  height: 33px;
  text-align: center;
  line-height: 33px;
  background: #ff7b00;
  margin: 0 12px;
  color: white;
  border-radius: 5px;
}
.btns button:last-of-type {
  background: #d1d1d1;
}
</style>

<style>
.uploads .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.uploads .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.uploads .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 98px;
  height: 98px;
  line-height: 98px;
  text-align: center;
}
.uploads .avatar {
  width: 98px !important;
  height: 98px !important;
  display: block;
}
.upload .avatar-uploader {
  margin-right: 20px;
  position: relative;
}
.upload .shili {
  width: 100px;
  height: 100px;
  display: block;
}
.upload .el-progress__text {
  transform: translate(150%, 120%) !important;
}
</style>